import React from 'react'
import { createRoot } from 'react-dom/client';
import { persistStore } from 'redux-persist';
import { PERSIST } from 'redux-persist/es/constants';
// Redux
// https://github.com/rt2zz/redux-persist
import {PersistGate} from 'redux-persist/integration/react'
import {Provider} from 'react-redux'
import * as _redux from './setup'
import store, {persistor} from './setup/redux/Store'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'

// Apps
import {App} from './app/App'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_library/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_library/assets/css/style.rtl.css'
 **/
import './_library/assets/sass/style.scss'
import './_library/assets/sass/core/fonts/PinyonScript-Regular.ttf';
import './_library/assets/sass/style.react.scss'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store)

Chart.register(...registerables)
const container = document.getElementById('root');
const root = createRoot(container!);
persistStore(store);
root.render(
  <>
  <Provider store={store}>
    {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
    {/*<PersistGate persistor={persistor} loading={<div>Loading...</div>}>*/}
    {/*  {() => (*/}
    {/*    <>*/}

          <App />
        {/*</>*/}
      {/*)}*/}
    {/*</PersistGate>*/}
  </Provider>
  </>
);
